export const COMMON_ROLES = ['FULL_ACCESS', 'COMPANY_ACCESS', 'TEMPLE_ADMIN'];
export const POOJA_MODULE_ROLES = ['POOJA_BILLING_ACCESS', 'POOJA_FULL_ACCESS'];
export const POOJA_REPORT_ROLES = ['POOJA_REPORT_ACCESS', 'POOJA_FULL_ACCESS'];
export const EXPENSE_MODULE_ROLES = ['EXPENSE_BILLING_ACCESS', 'EXPENSE_FULL_ACCESS'];
export const AUDITORIUM_MODULE_ROLES = ['AUDITORIUM_FULL_ACCESS', 'AUDITORIUM_BILLING_ACCESS'];
export const MEMBERSHIP_MODULE_ROLES = [
    'MEMBERSHIP_FULL_ACCESS', 'MEMBERSHIP_BILLING_ACCESS',
    'POOJA_FULL_ACCESS', 'REPORT_FULL_ACCESS'
];
export const BANK_MODULE_ROLES = ['BANK_TRANSACTION_BILLING_ACCESS', 'BANK_TRANSACTION_FULL_ACCESS'];
export const PAYROLL_MODULE_ROLES = ['PAYROLL_BILLING_ACCESS', 'PAYROLL_FULL_ACCESS'];
export const STORE_MODULE_ROLES = ['STORE_FULL_ACCESS', 'STORE_BILLING_ACCESS'];
export const RENTAL_MODULE_ROLES = ['RENTAL_BILLING_ACCESS', 'RENTAL_FULL_ACCESS'];
export const AUCTION_MODULE_ROLES = ['AUCTION_BILLING_ACCESS', 'AUCTION_FULL_ACCESS'];
export const ACCOMMODATION_MODULE_ROLES = ['ACCOMMODATION_BILLING_ACCESS', 'ACCOMMODATION_FULL_ACCESS'];
// WS-FHP (otas_backend/docs/FUNCTION_HALL_PRIEST_MODULE.md §4.6/§6.8): the two
// new roles seeded by changeset 052. Backend guards functionHallBillingAccess
// (reads + booking) / functionHallFullAccess (masters, settings, cancel,
// deposit release) mirror the accommodation pair, so the frontend family is
// composed exactly like ACCOMMODATION_MODULE_ROLES.
export const FUNCTION_HALL_MODULE_ROLES = ['FUNCTION_HALL_BILLING_ACCESS', 'FUNCTION_HALL_FULL_ACCESS'];
export const ACCOUNT_MODULE_ROLES = ['ACCOUNT_FULL_ACCESS'];
// WS-ACC Phase 0 (2026-07-25): the accountant role family accepted by the backend
// accounting guards (accountVoucherAccess / accountingWriteAccess). 'ACCOUNT' is the
// dedicated accountant role (role id 43, made assignable by backend changeset 048).
// Kept SEPARATE from ACCOUNT_MODULE_ROLES on purpose: guards like allBookingAccess
// (cheque enquiry) accept ACCOUNT_FULL_ACCESS but NOT ACCOUNT, so never spread this
// into a menu entry whose backend guard rejects 'ACCOUNT'.
export const ACCOUNTANT_ROLES = ['ACCOUNT', ...ACCOUNT_MODULE_ROLES];
export const REPORT_MODULE = ['REPORT_FULL_ACCESS'];
export const REPORT_MODULE_ACCESS = ['AUDITOR_ACCESS', ...REPORT_MODULE,
    ...POOJA_MODULE_ROLES,
    ...EXPENSE_MODULE_ROLES,
    ...AUDITORIUM_MODULE_ROLES,
    ...MEMBERSHIP_MODULE_ROLES,
    ...COMMON_ROLES,
    ...STORE_MODULE_ROLES
];
export const DEVASWOM_BILLING_MODULE = ['DEVASWOM_BILLING_ACCESS'];
export const DEVASWOM_REPORT_MODULE = ['DEVASWOM_REPORT_ACCESS'];
